import envConfig from 'configs/envConfig';
import { TPartnerAssets } from 'partners/types';
import { storedLocale } from 'partners/storedLocale';
import LunaLogoMark from 'assets/luna/logoMark.svg?react';

export const lunaBaseUrl = `${envConfig('b2BucketUrl')}/homeSecurity/luna`;

export const defaultAssets: TPartnerAssets = {
  logo: `${lunaBaseUrl}/logo.svg`,
  loginIllustration: `${lunaBaseUrl}/loginIllustration.svg`,
  Days30EventIcon: `${lunaBaseUrl}/30DaysEventIcon.svg`,
  CannotAddSelectedCameraIcon: `${lunaBaseUrl}/CannotAddSelectedCamera.svg`,
  attentionIcon: `${lunaBaseUrl}/attention.svg`,
  basicAlertsIcon: `${lunaBaseUrl}/basicAlertsIcon.svg`,
  basicMotionAlertsImg: `${lunaBaseUrl}/basicMotionAlerts.png`,
  clockIcon: `${lunaBaseUrl}/clockIcon.svg`,
  decriptiveAIAlertsIcon: `${lunaBaseUrl}/decriptiveAIAlertsIcon.svg`,
  firmwareVersionIcon: `${lunaBaseUrl}/firmwareVersionIcon.svg`,
  interntNotConnectedIcon: `${lunaBaseUrl}/interntNotConnected.svg`,
  limitedSecurityIcon: `${lunaBaseUrl}/limitedSecurityIcon.svg`,
  locationIcon: `${lunaBaseUrl}/location.svg`,
  logoContrastIcon: `${lunaBaseUrl}/logoContrast.svg`,
  logoWhiteIcon: `${lunaBaseUrl}/logoWhite.svg`,
  logoMarkIcon: LunaLogoMark,
  maxCameraLimitReachedIcon: `${lunaBaseUrl}/maxCameraLimitReached.svg`,
  AllCamerasAddedToAccountIcon: `${lunaBaseUrl}/AllCamerasAddedToAccount.svg`,
  noEventVideosIcon: `${lunaBaseUrl}/noEventVideosIcon.svg`,
  paymentFailedIcon: `${lunaBaseUrl}/paymentFailedIcon.svg`,
  DownGradeConfirmationIcon: `${lunaBaseUrl}/DownGradeConfirmation.svg`,
  paymentSuccessfulIcon: `${lunaBaseUrl}/PaymentSuccessful.svg`,
  planLevelOneIcon: `${lunaBaseUrl}/planLevelOneIcon.svg`,
  planLevelThreeIcon: `${lunaBaseUrl}/planLevelThreeIcon.svg`,
  planLevelTwoIcon: `${lunaBaseUrl}/planLevelTwoIcon.svg`,
  professionMonitoringIcon: `${lunaBaseUrl}/professionMonitoringIcons.svg`,
  // professionalMonitoringImg: `${lunaBaseUrl}/professionalMonitoring.png`,
  sampleCreditCardIcon: `${lunaBaseUrl}/sampleCreditCard.svg`,
  FreeTrialActivatedIcon: `${lunaBaseUrl}/FreeTrialActivated.svg`,
  upgradeSnapshotIcon: `${lunaBaseUrl}/upgradeSnapshot.svg`,
  wifiIcon: `${lunaBaseUrl}/wifiIcon.svg`,
  appQRCodeAndroid: `${lunaBaseUrl}/qrCodeAndroid.png`,
  appQRCodeIos: `${lunaBaseUrl}/qrCodeIos.png`,
  motionAlertsIcon: `${lunaBaseUrl}/motionAlerts.png`,
  snapshotIcon: `${lunaBaseUrl}/snapshotIcon.png`,
  liveViewIcon: `${lunaBaseUrl}/liveViewIcon.png`,
  dataIcon: `${lunaBaseUrl}/dataIcon.png`,
  noDataIcon: `${lunaBaseUrl}/noDataIcon.png`,
  autoDataRechargeDisabled: `${lunaBaseUrl}/autoDataRechargeDisabled.png`
};

// 2️⃣ Locale-specific overrides
const localeOverrides: Record<string, Partial<TPartnerAssets>> = {
  es: {
    basicMotionAlertsImg: `${lunaBaseUrl}/basicMotionAlerts-es.png`
  }
};

// 3️⃣ Merge default with overrides
export const getAssetsForLocale = (locale: string): TPartnerAssets => {
  return {
    ...defaultAssets,
    ...localeOverrides[locale]
  };
};

const locale = storedLocale();

export const assets = getAssetsForLocale(locale || 'en-US');
